import React, { useState, useEffect } from "react";
import { CheckIcon } from "@heroicons/react/outline";
import AirtimeForm from "./forms/AirtimeForm";
import ZesaForm from "./forms/ZesaForm";
import backgroundImage from "../assets/bgImage2png.png";
import SolutionOne from "./SolutionOne";
import SolutionTwo from "./SolutionTwo";
import SolutionThree from "./SolutionThree";
import SolutionHeading from "./SolutionHeading";
import FAQ from "./FAQ";
import Features4 from "./Carousel";
import MobileBanner from "./MobileBanner";

export default function Home() {
  const [selectedCountry, setSelectedCountry] = useState("zw");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("ZAR");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [meterNumber, setMeterNumber] = useState("");
  const [formType, setFormType] = useState("airtime");
  const [selectedService, setSelectedService] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const INTERNATIONAL_PHONE_NUMBER_REGEX = /^\+(?:[0-9] ?){6,14}[0-9]$/;

  const isValidPhoneNumber = (phoneNumber) => {
    return INTERNATIONAL_PHONE_NUMBER_REGEX.test(phoneNumber);
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setFormType(service);
  };

  const handleAirtimeSubmit = (e) => {
    e.preventDefault();
    if (!isValidPhoneNumber) {
      alert(
        "Invalid recipient phone number. Please enter a valid Zimbabwean format phone number"
      );
      return;
    }

    if (currency === "USD" && amount < 0) {
      alert("Invalid amount. Please enter an amount not less than 0 USD.");
    } else if (currency === "USD" && amount > 50) {
      alert("Invalid amount. Please enter an amount between 0 and 50 USD.");
    } else if (currency === "ZAR" && (amount < 5 || amount > 1000)) {
      alert("Invalid amount. Please enter an amount between 5 and 1000 ZAR.");
    } else {
      // submit the form
    }
    if (currency === "USD" && (amount < 5 || amount > 1000));

    const formattedPhone = `+${phone}`;
    const message = `JUSA ${amount} ${currency} to ${formattedPhone}`;
    const smsUrl = `sms:45776;?&body=${encodeURIComponent(message)}`;
    window.location.href = smsUrl;
  };

  const handleZesaSubmit = (e) => {
    e.preventDefault();
    const message = ` JUSA ${amount} ${currency} ZESA for  ${meterNumber}`;
    const smsUrl = `sms:45776;?&body=${encodeURIComponent(message)}`;
    window.location.href = smsUrl;
  };

  const handleCurrencyChange = (event) => {
    const currency = event.target.value;
    setCurrency(currency);
  };

  return (
    <div className="py-5">
      <MobileBanner />
      <div className="md:h-[90vh] xl:h-auto bg-gradient-to-br from-indigo-600 via-purple-700 to-indigo-800 pt-12 lg:pt-16 lg:h-[113vh] sm:h-[130vh] mt-24 sm:mt-12 max-w-full mx-auto relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-white bg-opacity-10 rounded-full animate-pulse"></div>
          <div className="absolute top-1/2 -left-10 w-32 h-32 bg-white bg-opacity-5 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 right-1/4 w-24 h-24 bg-white bg-opacity-10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        <div
          className={`grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 sm:mt-0 mb-6 pt-4 md:pt-8 lg:pt-0 max-w-full mx-auto transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
        >
          <div className="pt-8 lg:pt-20 ml-4 sm:ml-12 md:ml-16 col-span-1 md:self-center lg:mt-2 sm:mt-0 max-w-auto">
            <h2 className="text-center sm:text-center md:text-left lg:text-left font-poppins text-2xl sm:text-4xl md:text-5xl font-extrabold leading-normal text-white tracking-loose animate-fade-in-up">
              Fast & easy way <br /> To send airtime <br /> and buy electricity
            </h2>

            <h3 className="mt-8 text-center sm:text-center md:text-left lg:text-left font-poppins text-m sm:text-lg md:text-xl leading-normal text-white tracking-loose animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              JusaMusha lets you send airtime and buy electricity <br />
              instantly, at any local shop - no app, sign-up <br />
              or bank account required.
            </h3>

               <p className="pt-6 md:pt-12 sm:mx-0 pb-2 mt-4 text-left sm:text-center md:text-left text-sm sm:text-base md:text-lg font-roboto font-extrabold leading-6 text-navy">
              <ul className="flex flex-col items-center sm:items-start">
                <li>
                  <div class="border w-80 sm:w-80 sm:ml-20 lg:ml-2 mx-auto px-4 py-3 mb-4 rounded-lg bg-white inline-block relative flex-shrink-0">
                    <div class="flex items-center">
                      <div class="w-6 h-6 rounded-full bg-amber flex items-center justify-center mr-3">
                        <CheckIcon class="h-4 w-4 text-white stroke-width=4" />
                      </div>
                      <div>
                        <span class="text-sm sm:text-base">
                          Go to any spaza or shop near you
                        </span>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="border w-80 sm:w-80 sm:ml-20 lg:ml-2 mx-auto px-4 py-3 mb-4 rounded-lg bg-white inline-block relative flex-shrink-0">
                    <div class="flex items-center">
                      <div class="w-6 h-6 rounded-full bg-amber flex items-center justify-center mr-3">
                        <CheckIcon class="h-4 w-4 text-white stroke-width=4" />
                      </div>
                      <div>
                        <span class="text-sm sm:text-base">
                          Buy a OneVoucher or  OTT voucher
                        </span>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="border w-80 sm:w-80 sm:ml-20 lg:ml-2 mx-auto px-4 py-3 mb-4 rounded-lg bg-white inline-block relative flex-shrink-0">
                    <div class="flex items-center">
                      <div class="w-6 h-6 rounded-full bg-amber flex items-center justify-center mr-3">
                        <CheckIcon class="h-5 w-6 text-white stroke-width=4" />
                      </div>
                      <div>
                        <span class="text-sm sm:text-base">
                          Send "Hi" on{" "}
                          <a
                            href="https://wa.me/27769965252?text=Hi"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="text-amber underline"
                          >
                            WhatsApp to +27769965252
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="border w-80 sm:w-80 sm:ml-20 lg:ml-2 mx-auto px-4 py-3 mb-4 rounded-lg bg-white inline-block relative flex-shrink-0">
                    <div class="flex items-center">
                      <div class="w-6 h-6 rounded-full bg-amber flex items-center justify-center mr-3">
                        <CheckIcon class="h-5 w-6 text-white stroke-width=4" />
                      </div>
                      <div>
                        <span class="text-sm sm:text-base">
                          Follow the easy instructions from our automated service.
                        </span>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="border w-80 sm:w-80 sm:ml-20 lg:ml-2 mx-auto px-4 py-3 mb-4 rounded-lg bg-white inline-block relative flex-shrink-0">
                    <div class="flex items-center">
                      <div class="w-6 h-6 rounded-full bg-amber flex items-center justify-center mr-3">
                        <CheckIcon class="h-5 w-6 text-white stroke-width=4" />
                      </div>
                      <div>
                        <span class="text-sm sm:text-base">
                          That's it, your friend gets their airtime instantly. 24/7.
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </p>
          </div>
          

          <div className="flex flex-col mt-24 md:mt-44 pb-12 items-center justify-self-center animate-fade-in-up" style={{ animationDelay: '0.8s' }}>
            <div className="py-20 md:py-30 w-full sm:w-auto px-4 sm:px-2 lg:px-20 border border-gray-400 bg-white bg-opacity-95 backdrop-blur-lg rounded-3xl items-center sm:items-center md:self-center lg:mt-4 lg:py-8 lg:mx-4 shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105">
              <div className="text-center mb-8">
                <h2 className="pb-2 md:pb-4 text-center font-poppins tracking-tighter text-xl xs:text-4xl sm:text-3xl md:text-xl bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent animate-pulse">
                  Quick Top-Up
                </h2>
                <p className="text-gray-600 text-sm">Choose your service and get connected instantly</p>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="mt-6 flex justify-center">
  <a
    href="https://wa.me/27769965252"
    target="_blank"
    rel="noopener noreferrer"
    className="text-center w-full md:w-auto lg:w-full py-3 px-4 sm:px-12 xs:px-6 rounded-full hover:bg-amber-dark text-white bg-amber hover:bg-green-600 focus:outline-none focus:shadow-outline-blue flex items-center justify-center"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-..." /> {/* Replace with full path if needed */}
    </svg>
    Buy airtime
  </a>
</div>


<div className="mt-6 flex justify-center">
  <a
    href="https://wa.me/27769965252"
    target="_blank"
    rel="noopener noreferrer"
    className="text-center w-full md:w-auto lg:w-full py-3 px-4 sm:px-12 xs:px-6 rounded-full hover:bg-amber-dark text-white bg-amber hover:bg-green-600 focus:outline-none focus:shadow-outline-blue flex items-center justify-center"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-..." /> {/* Replace with full path if needed */}
    </svg>
    Buy ZESA
  </a>
</div>

              </div>

              <div className="bg-gradient-to-r from-orange-100 to-amber-100 rounded-2xl p-6 mb-6 text-center">
                <div className="text-amber-700 font-semibold text-lg mb-2">🇿🇼 Available for Zimbabwe</div>
                <div className="text-amber-600 text-sm">
                  Fast, secure, and reliable service<br />
                  24/7 customer support available
                </div>
              </div>

              {formType === "airtime" ? (
                <AirtimeForm
                  meterNumber={meterNumber}
                  setMeterNumber={setMeterNumber}
                  amount={amount}
                  setAmount={setAmount}
                  currency={currency}
                  handleCurrencyChange={handleCurrencyChange}
                  handleSubmit={handleAirtimeSubmit}
                  selectedService={selectedService}
                />
              ) : (
                <ZesaForm
                  meterNumber={meterNumber}
                  setMeterNumber={setMeterNumber}
                  amount={amount}
                  setAmount={setAmount}
                  currency={currency}
                  handleCurrencyChange={handleCurrencyChange}
                  handleSubmit={handleZesaSubmit}
                  selectedService={selectedService}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      
      <SolutionHeading />
      <SolutionThree />
      <SolutionOne />
      <Features4 />
      <SolutionTwo />
      <FAQ />

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-in-left {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }

        .animate-slide-in-left {
          animation: slide-in-left 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
      `}</style>
    </div>
  );
}